import React from "react";
import tw from "twin.macro"; //eslint-disable-line
import { css } from "styled-components/macro"; //eslint-disable-line
import AnimationRevealPage from "helpers/AnimationRevealPage.js";

import Hero from "components/hero/BackgroundAsImage.js";
import Features from "components/features/DashedBorderSixFeatures";
import MainFeature from "components/features/TwoColSingleFeatureWithStats2.js";
import MainFeature2 from "components/features/TwoColWithTwoFeaturesAndButtons.js";
import Portfolio from "components/cards/PortfolioTwoCardsWithImage.js";
import Blog from "components/blogs/ThreeColSimpleWithImageAndDashedBorder.js";
import Testimonial from "components/testimonials/TwoColumnWithImageAndProfilePictureReview.js";
import FAQ from "components/faqs/SimpleWithSideImage.js";
import ContactUsForm from "components/forms/TwoColContactUsWithIllustration.js";
import Footer from "components/footers/MiniCenteredFooter.js";
import customerSupportIllustrationSrc from "images/customer-support-illustration.svg";


import USGLogo from "images/testimonials/usg.png";
import USGPerson from "images/testimonials/usg-person.png";

import BikanerLogo from "images/testimonials/bikaner.png";
import BikanerPerson from "images/testimonials/bikaner-person.png";
export default () => (
  <AnimationRevealPage>
    <Hero />
    {/* <MainFeature /> */}
    <Features />
    {/* <MainFeature2 /> */}
    <Portfolio />
    <Testimonial
      subheading="Testimonials"
      heading={
        <>
          Our Clients <span tw="text-primary-500">Love Us.</span>
        </>
      }
      description="What Our Customers Are Saying  About Us."
      testimonials={[
        {
          imageSrc: USGPerson,
          profileImageSrc: USGLogo,
          quote:
            "An exceptional marketing partner. They managed all our marketing, promotions, and media for company events with complete professionalism—delivering strong brand visibility, seamless execution, and consistent impact every time.",
          customerName: "Anju Vallabhaneni",
          customerTitle: "CEO USG Inc."
        },
        {
          imageSrc: BikanerPerson,
          profileImageSrc: BikanerLogo,
          quote:
            "From our restaurant launch to every festival and networking event, the ad agency handled all marketing, promotions, and media management flawlessly. Their creative execution and timely delivery helped us build strong visibility and buzz from day one.",
          customerName: "Ketan Patel",
          customerTitle: "CEO (Bikanervala & Utility Networking)"
        }
      ]}
      textOnLeft={true}
    />
    {/* <FAQ
      imageSrc={customerSupportIllustrationSrc}
      imageContain={true}
      imageShadow={false}
      subheading="FAQs"
      heading={
        <>
          Do you have <span tw="text-primary-500">Questions ?</span>
        </>
      }
    /> */}
    {/* <Blog />
    <ContactUsForm /> */}
    <Footer />
  </AnimationRevealPage>
);
